/* tslint:disabled */
/* eslint-disable */
/**
 * Correlated sources
 * The service provides RESTful API for manipulating correlated sources (CRUD)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface CorrelatedSource
 */
export interface CorrelatedSource {
  /**
   *
   * @type {string}
   * @memberof CorrelatedSource
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof CorrelatedSource
   */
  tenantId?: string
  /**
   *
   * @type {string}
   * @memberof CorrelatedSource
   */
  idnSourceId?: string
  /**
   *
   * @type {string}
   * @memberof CorrelatedSource
   */
  idnSourceName?: string
  /**
   *
   * @type {string}
   * @memberof CorrelatedSource
   */
  camSourceId?: string
}

export function CorrelatedSourceFromJSON(json: any): CorrelatedSource {
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    tenantId: !exists(json, 'tenantId') ? undefined : json['tenantId'],
    idnSourceId: !exists(json, 'idnSourceId') ? undefined : json['idnSourceId'],
    idnSourceName: !exists(json, 'idnSourceName')
      ? undefined
      : json['idnSourceName'],
    camSourceId: !exists(json, 'camSourceId') ? undefined : json['camSourceId']
  }
}

export function CorrelatedSourceToJSON(value?: CorrelatedSource): any {
  if (value === undefined) {
    return undefined
  }
  return {
    id: value.id,
    tenantId: value.tenantId,
    idnSourceId: value.idnSourceId,
    idnSourceName: value.idnSourceName,
    camSourceId: value.camSourceId
  }
}
